import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "" }
const _hoisted_22 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_23 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "mt-15 mt-md-0" }
const _hoisted_30 = { class: "pagination mb-0" }
const _hoisted_31 = {
  key: 0,
  class: "page-item"
}
const _hoisted_32 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "page-item"
}
const _hoisted_35 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_36 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_37 = { class: "modal-content" }
const _hoisted_38 = { class: "modal-header" }
const _hoisted_39 = { class: "modal-title fs-5" }
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { style: {} }
const _hoisted_42 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_45 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_46 = { class: "modal-footer" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_49 = { style: {"color":"#FFF"} }
const _hoisted_50 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_51 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_52 = { class: "modal-content" }
const _hoisted_53 = { class: "modal-header" }
const _hoisted_54 = { class: "modal-title fs-5" }
const _hoisted_55 = { class: "modal-body" }
const _hoisted_56 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_57 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_58 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_59 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_60 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_61 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_65 = ["placeholder"]
const _hoisted_66 = { class: "invalid-feedback" }
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = { class: "invalid-feedback" }
const _hoisted_71 = { class: "modal-footer" }
const _hoisted_72 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_73 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}

import {ref, onMounted,reactive,inject } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useTableFilter } from "../../utils/UseTablefilter";
import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import {Providor } from "@/utils/Model";

import {current_permissions} from '../../utils/permission';
import {showToast,checkSessionValidate} from "@/utils/function";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProvidorContent',
  setup(__props) {

const backApi=inject('back');

const btnLoad = ref(true);
const { t } = useI18n();
const selectedValidation = ref('N');
const selected = ref(false);


const loader = ref(false);

let token: string|null = localStorage.getItem('login_token');
let codeOrganization: string|null = localStorage.getItem('organization_code');
let codeUser: string|null = localStorage.getItem('code');
let role: string|null = localStorage.getItem('role');

const providors =ref(new Array<Providor>());
let edit = 0;
let itemCode = '';
let selectedOrganization = '';



const {
  searchQuery,
  paginatedData: paginatedTypeFees,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  providors,
  [
    (t: any) => t.code,
    (t: any) => t.name,
    (t: any) => t.description,
    (t: any) => t.status,
  ],
  15
);

  let data = [];
 
  const errors = ref('');  
  const errorId = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','description':''};
  const pageLoad = ref(false);

  const formValues = reactive({    
    name: "",  
    description: ""
  });

  
  const schema = yup.object({    
      name: yup.string().required('Le nom est requis'),  
      description: yup.string().required('La description est requise'),  
      
  });

  

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}


const initField = () =>{
  formValues.name=  '';  
  formValues.description= ''; 
  edit=0;
}


const fetchProvidorsPage = (targetPage: number) => {
  const url = `${backApi}/secure/providers/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getProvidors = async () => {
  try {
    const first = await fetchProvidorsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchProvidorsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    providors.value = collected;
    data = collected;
    page.value = 1;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const showProvidor = (code) =>{
    // +arg
     axios.get(backApi+'/secure/providers/'+code+'/show',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        formValues.name=  response.data.name;  
        formValues.description=  response.data.description; 
        itemCode = response.data.code;
        

        edit=1;        
        // console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}



const showScreen = (code)=>{ 
  itemCode=code;
  
}

const cancel = () =>{
  itemCode="";
  errorId.value="";
  errors.value="";
}

const save =()=>{
  if (edit==0){
    storeProvidor()
  }else{
    updateProvidor()
    
  }
  
}


const storeProvidor =()=>{
  btnLoad.value=false; 
try {  
  schema.validateSync(formValues);
   
  axios.post(`${backApi}/secure/providers/new`,{          
          name:formValues.name,
          description:formValues.description,
          
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        btnLoad.value=true;
        if(response.status === 201){ 
          console.log(response);          
          showToast("Enregistrement effectué avec succès","green");
          router.go();  
        }      
        
    }).catch((error) => {
      btnLoad.value=true;
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         btnLoad.value=true;
              
}

}

const updateProvidor =()=>{
  btnLoad.value=false;
try {  
  schema.validateSync(formValues);
  // alert(formValues)
  axios.put(`${backApi}/secure/providers/${itemCode}/edit`,{          
          name:formValues.name,
          description:formValues.description,
          code:itemCode,     
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {            
        btnLoad.value=true;
        if(response.status === 200){   
          showToast("Modification effectuée avec succès","green");            
          router.go();  
        }      
        
    }).catch((error) => {
      btnLoad.value=true;
      // alert(error.response.data.errorId);
          if( error.response){
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         btnLoad.value=true;       
              
}

}

const deleteBusiness =()=>{
  btnLoad.value=false;
try {   
  // alert(itemCode);
  const headers = {
  'Authorization':  `Bearer ${token}`
  }
const data = {
  code: itemCode
}
  axios.delete(`${backApi}/secure/business/delete`, {headers, data})
  .then(response => {
    if(response.status === 200){ 
      btnLoad.value=true;
          console.log(response);          
          router.go();  
        }   
})
.catch(error => {
  if( error.response){
      
      if(error.response.status === 401){
        router.push('/')
        
      }else{
        errorId.value=error.response.data.errorId;
        errors.value=error.response.data.message;
      } 
      
  }
});

} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}

const exportExcel = () =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE RECHARGEMENT","DESCRIPTION","MONTANT","DATE","STATUT"];
    const Fields = ["code","description","amount","createdAt","status"];//mnoName
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"rechargement",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


onMounted(async () => { 
  checkSessionValidate(1);
  await getProvidors();
   
   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
 
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: "Rechercher..."
              }, null, 512), [
                [_vModelText, _unref(searchQuery)]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_unref(current_permissions)('create_provider'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.addProvider')) + " ", 1),
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('providers.code')), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('providers.name')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('providers.description')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('providers.type')), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedTypeFees), (providor) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: providor.code
                    }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(providor.code), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(providor.name), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(providor.description), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(providor.type), 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[14] || (_cache[14] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_19, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('edit_provider'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#companyModal",
                                    onClick: ($event: any) => (showProvidor(providor.code))
                                  }, [
                                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('providers.edit')), 1)
                                  ], 8, _hoisted_20))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_unref(filteredTotal)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_unref(filteredTotal)>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                        _createTextVNode(_toDisplayString(_ctx.$t('feeTypes.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(page)*10), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filteredTotal)<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                        _createTextVNode(_toDisplayString(_ctx.$t('feeTypes.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_29, [
                    _createElementVNode("ul", _hoisted_30, [
                      ((_unref(page)-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPage)(_unref(page)-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numPages), (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==_unref(page))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_32, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (_unref(goToPage)(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_33))
                        ]))
                      }), 128)),
                      ((_unref(page)+1)<=_unref(numPages))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPage)(_unref(page)+1))),
                              "aria-label": "Next"
                            }, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("h1", _hoisted_39, _toDisplayString(_ctx.$t('providers.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              (errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_42, _toDisplayString(_ctx.$t('providers.confirmDelete')), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("h6", _hoisted_44, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_45, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('providers.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteBusiness()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('providers.yes')), 1)
            ], 8, _hoisted_47)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("h1", _hoisted_54, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('providers.addProvider') : _ctx.$t('providers.editProvider')), 1),
              _cache[17] || (_cache[17] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_55, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("h6", _hoisted_57, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_58, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("h6", _hoisted_60, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('providers.providerName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        placeholder: _ctx.$t('providers.providerNamePlaceholder'),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.name) = $event)),
                        id: "name",
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_65), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_66, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('providers.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        placeholder: _ctx.$t('providers.descriptionPlaceholder'),
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formValues.description) = $event)),
                        id: "description",
                        onBlur: _cache[9] || (_cache[9] = ($event: any) => (validate('description')))
                      }, null, 42, _hoisted_69), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_70, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              (_unref(current_permissions)('create_provider','edit_provider'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_72, [
                    (!btnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_73))
                      : _createCommentVNode("", true),
                    _cache[18] || (_cache[18] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('providers.save') : _ctx.$t('providers.edit')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})